import { cva } from 'class-variance-authority';
import { IconProps } from '../icon/Icon';

// Shared button variant styling
export const buttonVariants = cva('button', {
  variants: {
    variant: {
      primary: 'button-primary',
      secondary: 'button-secondary',
      tertiary: 'button-tertiary',
      text: 'button-text',
      'text-negative': 'button-textNegative',
      outlined: 'button-outlined',
      'tertiary-negative': 'button-tertiaryNegative',
      'secondary-negative': 'button-secondaryNegative',
      icon: 'button-icon',
    },
    format: {
      full: 'full',
      small: 'small',
      marketing: 'marketing',
    },
    outsidePadding: {
      true: 'px-card-padding-large',
      false: '',
    },
    sticky: {
      true: 'sticky',
      false: '',
    },
  },
  defaultVariants: {
    variant: 'primary',
    format: 'full',
    outsidePadding: false,
  },
});

// Shared types for button props
export interface BaseButtonProps {
  labelText: string;
  className?: string;
  leadingIcon?: Pick<IconProps, 'fileName' | 'size'>;
  trailingIcon?: Pick<IconProps, 'fileName' | 'size'>;
  isLoading?: boolean;
  loadingText?: string;
  sideBySide?: boolean;
  sticky?: boolean | null;
}
